export const CURRENCIES = [
  { code: "USD", symbol: "$", label: "USD — US Dollar" },
  { code: "EUR", symbol: "€", label: "EUR — Euro" },
  { code: "GBP", symbol: "£", label: "GBP — British Pound" },
  { code: "CAD", symbol: "CA$", label: "CAD — Canadian Dollar" },
  { code: "AUD", symbol: "A$", label: "AUD — Australian Dollar" },
  { code: "NZD", symbol: "NZ$", label: "NZD — New Zealand Dollar" },
  { code: "INR", symbol: "₹", label: "INR — Indian Rupee" },
  { code: "MXN", symbol: "MX$", label: "MXN — Mexican Peso" },
  { code: "ARS", symbol: "ARS$", label: "ARS — Argentine Peso" },
  { code: "ZAR", symbol: "R", label: "ZAR — South African Rand" },
  { code: "KES", symbol: "KSh", label: "KES — Kenyan Shilling" },
  { code: "NGN", symbol: "₦", label: "NGN — Nigerian Naira" },
  { code: "JPY", symbol: "¥", label: "JPY — Japanese Yen" },
  { code: "CNY", symbol: "CN¥", label: "CNY — Chinese Yuan" },
  { code: "AED", symbol: "AED", label: "AED — UAE Dirham" },
];

export const LIVESTOCK = [
  {
    id: "cattle",
    name: "Cattle",
    subtitle: "Dairy & Beef",
    icon: "Beef",
    unit: "Head",
    register: "Herd",
    metrics: ["Daily Milk Yield (L)", "Average Weight (kg)", "Calving Rate (%)", "Feed Intake (kg/day)"],
    activities: ["Milking Log", "Artificial Insemination / Breeding", "Vaccination & Vet Check", "Pasture Rotation", "Silage / Hay Feeding", "Weight Measurement", "Livestock Sale"],
    image: "https://images.unsplash.com/photo-1566310203664-bb0828838943?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
  },
  {
    id: "poultry",
    name: "Poultry",
    subtitle: "Layers & Broilers",
    icon: "Egg",
    unit: "Birds",
    register: "Birds",
    metrics: ["Daily Egg Count (Crates)", "Feed Conversion Ratio", "Mortality Rate (%)", "Coop Temp (°C)"],
    activities: ["Egg Collection & Sorting", "Feed Batch Distribution", "Coop Sanitization", "Flock Vaccination", "Broiler Weight Check", "Bird Sale"],
    image: "https://images.unsplash.com/photo-1723357018190-c0163698165b?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
  },
  {
    id: "sheep",
    name: "Sheep",
    subtitle: "Wool & Mutton",
    icon: "Cloud",
    unit: "Flock",
    register: "Flock",
    metrics: ["Wool Yield (kg)", "Lambing Percentage", "Weight Gain Rate", "Drenching Schedule"],
    activities: ["Shearing Log", "Lambing Record", "Deworming / Drenching", "Pasture Grazing Shift", "Fleece Grade Sorting", "Wool Sale"],
    image: "https://images.unsplash.com/photo-1695076721761-7eb530f1ef4d?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
  },
  {
    id: "goats",
    name: "Goats",
    subtitle: "Dairy & Meat",
    icon: "Milk",
    unit: "Herd",
    register: "Herd",
    metrics: ["Caprine Milk (L/day)", "Kidding Success Rate", "Forage Consumption", "Hoof Trim Status"],
    activities: ["Goat Milking Session", "Hoof Care & Trimming", "Herding & Browse Feed", "Kidding Registration", "Vet Examination", "Goat Sale"],
    image: "https://images.unsplash.com/photo-1601284703470-0afd2fcf7ccc?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
  },
  {
    id: "plants",
    name: "Crops",
    subtitle: "Plants & Harvest",
    icon: "Sprout",
    unit: "Plots",
    register: "Field",
    metrics: ["Harvest Yield (kg)", "Germination Rate (%)", "Days to Maturity", "Expected Sale Value"],
    activities: ["Planting / Sowing", "Weeding", "Irrigation", "Fertilizer Application", "Pest Control", "Harvest Log", "Crop Sale"],
    image: "https://images.unsplash.com/photo-1500382017468-9049fed747ef?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
  },
];

export const CROPS = [
  { id: "maize", name: "Maize / Corn", grow_days: 100, yield_per_plant: 0.25, unit: "kg", price_per_unit: 0.5 },
  { id: "tomato", name: "Tomato", grow_days: 80, yield_per_plant: 4, unit: "kg", price_per_unit: 1.2 },
  { id: "wheat", name: "Wheat", grow_days: 120, yield_per_plant: 0.03, unit: "kg", price_per_unit: 0.4 },
  { id: "beans", name: "Beans", grow_days: 85, yield_per_plant: 0.15, unit: "kg", price_per_unit: 1.5 },
  { id: "cassava", name: "Cassava", grow_days: 300, yield_per_plant: 3, unit: "kg", price_per_unit: 0.3 },
  { id: "rice", name: "Rice", grow_days: 130, yield_per_plant: 0.05, unit: "kg", price_per_unit: 0.6 },
  { id: "potato", name: "Potato", grow_days: 90, yield_per_plant: 0.8, unit: "kg", price_per_unit: 0.7 },
  { id: "cabbage", name: "Cabbage", grow_days: 70, yield_per_plant: 1.2, unit: "head", price_per_unit: 0.9 },
  { id: "vegetables", name: "Vegetables", grow_days: 75, yield_per_plant: 1, unit: "kg", price_per_unit: 1 },
];

export const cropById = (id) => CROPS.find((c) => c.id === id) || CROPS[0];

export const INCOME_CATEGORIES = ["Milk Sales", "Egg Sales", "Livestock Sales", "Wool Sales", "Meat Sales", "Crop Sales", "Contract Sale", "Manure Sales", "Other Income"];
export const EXPENSE_CATEGORIES = ["Feed & Fodder", "Veterinary", "Labor", "Utilities", "Fuel", "Equipment", "Breeding", "Transport", "Maintenance", "Seeds & Inputs", "Other Expense"];

export const BIRD_CATEGORIES = [
  { id: "layers", name: "Layers", note: "Egg hens", lay_days: 126, meat_days: 504 },
  { id: "broilers", name: "Broilers", note: "Meat chickens", lay_days: 0, meat_days: 42 },
  { id: "noilers", name: "Noilers", note: "Eggs & meat", lay_days: 140, meat_days: 84 },
];

export const addDays = (d, n) => {
  if (!d || !n) return "";
  const dt = new Date(d + "T00:00:00");
  dt.setDate(dt.getDate() + Number(n));
  return dt.toISOString().slice(0, 10);
};

export const livestockById = (id) => LIVESTOCK.find((l) => l.id === id) || LIVESTOCK[0];
